import { Tags } from '@services/measurement/Measurement';
import { ADPTags } from '@services/types';

export const toADPTags = (tags: Tags | undefined): ADPTags =>
    !!tags
        ? Object.entries(tags).reduce(
              (acc, [key, value]) => ({
                  ...acc,
                  [key]: `${value}`,
              }),
              {}
          )
        : {};
